<template>
    <v-container :class="!showSearchBox?'pb-1 pt-1 pl-0 ml-0 pr-0 mr-0 fluid':'pb-1 pt-1 fluid'" :style="'padding:0;'">    
        <div :class="!isMobile?'clsspace':''">
        <div v-for="(input,k) in inputs" :key="k">
            <v-layout row wrap v-show="showSearchBox">
            <v-flex md12 xs12>
                <v-layout row wrap>
                    <v-flex md6 xs6>
                        <label :style="'font-weight:bold;'">Flight {{k+1}}</label>
                    </v-flex>
                    <v-flex md6 xs6 v-show="isMobile">
                        <v-btn flat icon small @click="remove(k);" :style="'float:right; margin:0;'">
                        <v-icon>remove_circle_outline</v-icon>
                        </v-btn>
                    </v-flex>
                    <v-flex md6 xs6 v-show="!isMobile">
                    </v-flex>    
                </v-layout>
            </v-flex>           
            <v-flex md6 xs12>
                <v-layout row wrap>
                    <v-flex md6 xs12>
                        <AirportSelector :disabled="searchBoxControlsDisabilities.originSelector" 
                        :setAirport="storedSearchBoxValues.originM[k]" 
                        :cityAirports="cityAirports" 
                        @airportSelected="airport => searchPara.originM[k]=airport" icon="flight_takeoff"/>
                    </v-flex>
                    <v-flex md6 xs12>
                        <AirportSelector :disabled="searchBoxControlsDisabilities.destinationSelector" 
                        :setAirport="storedSearchBoxValues.destinationM[k]" 
                        :cityAirports="cityAirports" 
                        @airportSelected="airport => searchPara.destinationM[k]=airport" icon="flight_land"/>                
                    </v-flex>
                </v-layout>
            </v-flex>            
            <v-flex md2 xs12>
                <v-layout row wrap>
                  <v-flex md12 xs12>
                      <v-menu class="hundred-percent-width">
                          <v-text-field
                              label="Departure"
                              slot="activator"
                              prepend-icon="date_range"
                              :value="searchPara.departureDateM[k]"
                              :disabled="searchBoxControlsDisabilities.dateOfDeparturePicker"
                          ></v-text-field> 
                          <v-date-picker :disabled="searchBoxControlsDisabilities.dateOfDeparturePicker" 
                          @input="departureDateChanged(k)" 
                          v-model="searchPara.departureDateM[k]"></v-date-picker>
                      </v-menu>
                  </v-flex>
                </v-layout>
            </v-flex>
            <v-flex md1 xs12 v-show="!isMobile">  
                <v-btn flat icon small @click="remove(k);" :style="'margin-top:15px;'">
                <v-icon>remove_circle_outline</v-icon>
                </v-btn>
            </v-flex>                                             
        </v-layout>
        </div>
        
        <v-layout row wrap v-show="showSearchBox">
            <v-flex md6 xs12>
                <v-layout>
                    <v-flex md12 xs12 v-show="lnkAdd">
                        <a @click="add();">+ add new flight</a>
                    </v-flex>                   
                </v-layout>
            </v-flex>  
            
            <v-flex md3 xs12 :style="!isMobile?'margin-left:-5%;':''">
                <v-layout row wrap>                
                    <v-flex md12 xs12>
                        <v-layout>
                            <v-flex md7 xs12 pr-1>
                                <PassengerBox
                                :setPassengerCountByPax="storedSearchBoxValues.passengerCountByPax"
                                @seatClassSelected="c=>searchPara.seatClass=c"
                                @passengerCounts="pc=>getPassengerCounts(pc)"
                                :disabled="searchBoxControlsDisabilities.passengerPicker"
                                />     
                            </v-flex>           
                            <v-flex md5 xs12>
                                <v-btn :disabled="searchBoxControlsDisabilities.searchButton" 
                                color="primary" class="trimmed-button hundred-percent-width" @click="submitSearch(searchPara);">Search</v-btn>         
                            </v-flex>                   
                        </v-layout>                    
                    </v-flex>
                </v-layout>
            </v-flex>                                             
        </v-layout>
        </div>
        <v-alert :value="validation.showAlert" type="error" :style="!isMobile?'margin:0 23.4% 0 22%;':''">{{validation.message}}</v-alert>
        <v-layout row wrap v-show="showSearchBox" :style="'border-bottom:solid 2px #e6e6e6; margin-top:4px;'">
        </v-layout>
         <v-layout v-show="!showSearchBox" row wrap>
            <v-flex md12>
                <v-layout row>
                    <v-spacer v-if="!isMobile"></v-spacer>
                    <v-flex md2>
                        <v-btn-toggle style="background:transparent;" multiple>
                            <v-btn flat class="pt-2" :href="backToHomeUrl"><v-icon>home</v-icon>&nbsp;&nbsp;Home</v-btn>
                            <v-btn flat @click="copyLink" class="pt-2" :disabled="searchBoxControlsDisabilities.copyLinkButton"><v-icon>link</v-icon>&nbsp;Copy Link</v-btn>
                        </v-btn-toggle>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex md12>
                <v-card flat color="primary" dark :class="isMobile?'pl-0 pr-0':'pl-4 pr-4'">
                    <v-card-text>
                    <v-layout row>
                        <v-flex xs8 md8>
                            <v-layout row wrap>
                                <v-flex md12>
                                    <!-- <v-layout row wrap>
                                        <v-flex md12 v-for="(input,index) in searchPara.originM" :key="index">
                                            <span>{{getAirportCode(searchPara.originM[index])}}&nbsp;&nbsp;-&nbsp;&nbsp;{{getAirportCode(searchPara.destinationM[index])}}&nbsp;&nbsp;&nbsp;{{searchPara.departureDateM[index]}}</span>
                                        </v-flex>                                                                             
                                    </v-layout> -->
                                    <div v-if="!isMobile">
                                      <v-layout row wrap md12 v-for="(input,indDsk) in searchPara.originM" :key="indDsk">
                                          <v-flex md1>Flight {{indDsk+1}}</v-flex>
                                          <v-flex md4>{{searchPara.originM[indDsk]}}</v-flex>
                                          <v-flex md4>{{searchPara.destinationM[indDsk]}}</v-flex>
                                          <v-flex md2 pl-3>{{searchPara.departureDateM[indDsk]}}</v-flex>                                                                             
                                      </v-layout>
                                    </div>
                                    <div v-if="isMobile">
                                      <v-layout row wrap md12 v-for="(input,indMb) in searchPara.originM" :key="indMb">
                                          <v-flex xs3>{{getAirportCode(searchPara.originM[indMb])}}</v-flex>
                                          <v-flex xs3>{{getAirportCode(searchPara.destinationM[indMb])}}</v-flex>
                                          <v-flex xs6>{{searchPara.departureDateM[indMb]}}</v-flex>                                                                             
                                      </v-layout>
                                    </div>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs3 md3>
                            <v-layout row wrap>                                
                                <v-flex md12>
                                    <v-layout row wrap>
                                        <v-flex md12>{{selectedSeatClass}}</v-flex>                                        
                                        <v-flex md12>
                                            <label>{{searchPara.adtPassengerCount!=0? 'Adults:'+ searchPara.adtPassengerCount:''}}</label><br v-if="isMobile">
                                            <label>&nbsp;{{searchPara.cnnPassengerCount!=0? 'Children:'+ searchPara.cnnPassengerCount:''}}</label><br v-if="isMobile">
                                            <label>&nbsp;{{searchPara.infPassengerCount!=0? 'Infants:'+ searchPara.infPassengerCount:''}}</label><br v-if="isMobile">
                                            <label>&nbsp;{{searchPara.stuPassengerCount!=0? 'Student:'+ searchPara.stuPassengerCount:''}}</label>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs1 md1>
                            <v-btn small :color="defaultColors.secondary" fab @click="lnkedit()" :style="isMobile?'height:28px;width:28px;':''" ><v-icon>edit</v-icon></v-btn>
                        </v-flex>                        
                    </v-layout>                        
                    </v-card-text>

                </v-card>
            </v-flex>
        </v-layout>
        <v-progress-linear v-if="indeterminate" :indeterminate="indeterminate"></v-progress-linear>
          <v-dialog
      v-model="showCopyLinkDialog"
      width="500"
      height="300"
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Copy link
        </v-card-title>

        <v-card-text>
            <v-textarea :value="linkToCopy" outline background-color="#808080"></v-textarea>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="copyLinkDialogClick()"
            v-clipboard:copy="linkToCopy"
            v-clipboard:success="onCopyToClipboard"
            v-clipboard:error="onCopyToClipboardErr"
          >
            Copy
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
            :top="true"
            :timeout="3000"
            v-model="snackbar.show"
            class="text-md-center"
            color="#ce971c"
        >{{snackbar.text}}
            <v-btn
                color="white"
                flat
                @click="snackbar.show = false"
            >
                Close
            </v-btn>
        </v-snackbar>  
    </v-container>

</template>

<script>
import MulticityBox from "./MulticityBox.code.js"

export default MulticityBox;
</script>

<style>
.hundred-percent-width{
    width: 100%;
}
.trimmed-button{
    margin-left: 0px;
    margin-right: 0px;
}
.number-of-passenger{
    width:100%;
    text-align: center;
}
.clsspace{
    margin-left: 22%;
}
@media only screen and (max-width: 959px){
    .v-input__append-outer {
    margin-left: 0px;
    }
}
</style>
